<template>
  <section id="question10">
    <div
      class="sort-description d-flex justify-content-between align-items-center"
    >
      <span
        @click="reset"
        class="reset d-flex justify-content-between align-items-center"
      >
        <span>重新選擇</span>
        <img class="loop-circular" src="@/assets/icons/loop-circular.svg" />
      </span>
    </div>
    <CRow>
      <CCol md="5">
        <div class="drag-sort h-100">
          <div v-if="+info.is_help" class="mask"></div>
          <div class="drag-sort-title">請依據排序順序點擊選項</div>
          <draggable
            class="drag-sort-option-wrapper"
            :list="optionList"
            :group="groupOption"
            itemKey="value"
          >
            <template #item="{ element }">
              <div @click="() => add(element)" class="drag-sort-option">
                {{ element.title }}
              </div>
            </template>
          </draggable>
        </div>
      </CCol>
      <CCol
        class="d-flex justify-content-center align-items-center h-full"
        md="2"
      >
        <img src="@/assets/icons/cross-arrow.svg" />
      </CCol>
      <CCol md="5">
        <div class="drag-sort h-100">
          <div v-if="+info.is_help" class="mask"></div>
          <div class="drag-sort-title">按住選項可拖曳調整排序順序</div>
          <draggable
            class="drag-sort-option-wrapper"
            :list="sortSelections"
            :group="groupOption"
            itemKey="value"
          >
            <template #item="{ element }">
              <div @click="() => remove(element)" class="drag-sort-option">
                {{ element.title }}
              </div>
            </template>
          </draggable>
        </div>
      </CCol>
    </CRow>
  </section>
</template>
<script>
import { ref } from '@vue/reactivity'
import Draggable from 'vuedraggable'
import { computed, onMounted, watch } from '@vue/runtime-core'

export default {
  components: {
    Draggable,
  },
  emits: ['content'],
  props: {
    info: {
      type: Object,
      default: () => {},
    },
  },
  setup(props, { emit }) {
    const sortSelections = ref([])
    const optionAry = ref([])
    const idArray = ref([])
    onMounted(() => {
      getItemsIndex()
      emitContent()
    })
    const getItemsIndex = () => {
      props.info.extension_info.items.forEach((e, i) => {
        optionAry.value.push({
          title: e,
          index: i,
        })
      })
    }
    const groupOption = computed(() => {
      return {
        pull: true,
        name: props.info.part_item_id,
      }
    })
    const add = (element) => {
      const id = optionAry.value.findIndex((option) => option === element)
      const target = optionAry.value.splice(id, 1)
      sortSelections.value.push(...target)
    }

    const remove = (element) => {
      const id = sortSelections.value.findIndex((option) => option === element)
      const target = sortSelections.value.splice(id, 1)
      optionAry.value.push(...target)
    }
    const reset = () => {
      optionAry.value = []
      getItemsIndex()
      sortSelections.value = []
    }
    const emitContent = async () => {
      const answerIndex = sortSelections.value.map((e) => e.index)
      emit('content', {
        part_item_id: props.info.part_item_id,
        type: props.info.type,
        is_help: +props.info.is_help ? '1' : '0',
        help_message: props.info?.help_message ||'',
        is_finish: !![...answerIndex].length,
        value_info: +props.info.is_help === 0 ? [...answerIndex] : [],
      })
    }
    watch(
      sortSelections,
      () => {
        emitContent()
      },
      { immediate: true, deep: true },
    )
    watch(
      () => props.info.value_info,
      async (newValue) => {
        if (!newValue || !Array.isArray(newValue) || !newValue.length) return
        await getItemsIndex()
        const arr = JSON.parse(JSON.stringify(optionAry.value))
        optionAry.value = []
        newValue.forEach((e, i) => {
          sortSelections.value.splice(
            i,
            0,
            arr.find((x) => x.index === e),
          )
        })
      },
      { immediate: true },
    )
    watch(
      () => props.info.is_help,
      () => {
        emitContent()
      },
    )
    return {
      sortSelections,
      emitContent,
      groupOption,
      add,
      remove,
      idArray,
      reset,
      optionList: optionAry,
    }
  },
}
</script>
<style lang="scss" scoped>
.drag-sort {
  position: relative;
  .mask{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 2;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
  }
  .drag-sort-title {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 8px 16px;
    gap: 10px;
    background: #4d4d4d;
    border-radius: 10px 10px 0px 0px;
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    letter-spacing: 2px;
    color: #ffffff;
  }
  .drag-sort-option-wrapper {
    height: calc(100% - 30px);
    border-width: 0px 1px 1px 1px;
    border-style: solid;
    border-color: #cccccc;
    border-radius: 0px 0px 10px 10px;
  }
  .drag-sort-option {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 14px 15px;
    font-family: 'Noto Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 2px;
    color: #4d4d4d;
    border-width: 1px 0px 0px 0px;
    border-style: solid;
    border-color: #cccccc;
    border-radius: 0px;
    cursor: pointer;
  }
}
.sort-description {
  margin-bottom: 18px;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
  }
  > span:nth-child(1) {
    color: #187baf;
  }
  .reset {
    cursor: pointer;
    color: #4d4d4d;
  }
  .loop-circular {
    margin-left: 8px;
    width: 16px;
    height: 22px;
  }
}
</style>
